var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"py-0",attrs:{"md":_vm.md,"lg":_vm.lg,"sm":_vm.sm,"offset":_vm.offset}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }